export default __webpack_public_path__ + "static/media/step1.4605f57f.svg";